import "./Icons.css";


const Icon = function (props) {
    return (
        <div className="col-6 col-md-3 IconWrap" >
            <div className="card" id={'IconCard'+props.data.ModLinksDisplayOrder}>
                <a href={props.data.ModLinksLink.NavigateUrl} title={props.data.title}>
                    <div className="card-body">
                    <img className="cardImg" src={ props.data.MODisplaylImage.ImageUrl} data-holder-rendered="true" />
                        <div className="justify-content-between align-items-center">
                            <div className="card-text">{props.data.Title}</div>
                            <div className="traingle-bottom orange-traingle"></div>
                        </div>
                    </div>
                </a>
            </div>
       </div>
    );
}

export default Icon;